import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-trustkeysHeader text-white text-center py-4">
      <p>Copyright &copy; 2024 TrustKeys Network</p>
    </footer>
  );
};

export default Footer;
